import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dayCell", "dayPanel"]
  static values = { mode: String, selectedDate: String }

  connect() {
    const today = new Date().toISOString().split("T")[0]
    const firstDate = this.dayCellTargets[0]?.dataset.date
    const dateToSelect = this.dayCellTargets.find(c => c.dataset.date === today) ? today : firstDate

    if (dateToSelect) {
      // Defer so the full page layout is settled before scrolling
      requestAnimationFrame(() => this.selectDay(dateToSelect))
    }
  }

  select(event) {
    event.preventDefault()
    const date = event.currentTarget.dataset.date
    if (date) this.selectDay(date)
  }

  selectDay(date) {
    this.selectedDateValue = date

    this.dayCellTargets.forEach(cell => {
      const isSelected = cell.dataset.date === date
      cell.classList.toggle("ring-2", isSelected)
      cell.classList.toggle("ring-primary", isSelected)
      cell.classList.toggle("bg-primary", isSelected)
      cell.classList.toggle("text-primary-content", isSelected)
    })

    if (this.modeValue === "agenda") {
      const target = document.getElementById(`agenda-day-${date}`)
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" })
    } else if (this.modeValue === "strip") {
      this.dayPanelTargets.forEach(panel => {
        panel.classList.toggle("hidden", panel.dataset.date !== date)
      })
    }
  }
}
